import { EventInfoDTO } from "./useEventInfoById";
import _ from "lodash";

export function canShowEventMap(eventInfo: EventInfoDTO): boolean {
  if (_.isNil(eventInfo.lat) || _.isNil(eventInfo.lng)) return false;
  return !!eventInfo.canViewPreciseLocation;
}
